"use client";

import { c as _c } from "react/compiler-runtime";
import { SectionHeader, StatsTable } from "fansunited-sports-ui";
import { mapStandingsToTable } from "@/utilities/mappers/standings";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
import { SITE_TYPE_FOOTBALL_TEAM } from "@/config/siteTypes";
import { tableStyles } from "@/utilities/styles/tableStyles";
import type { FormTables } from "@/utilities/data/competition/derive/types";
export function FormTablesTab(t0) {
  const $ = _c(152);
  const {
    formTables
  } = t0;
  const labels = useLabels().standings;
  const nav = useNavigation();
  const {
    siteType
  } = useTenantSettings();
  const teamHref = siteType === SITE_TYPE_FOOTBALL_TEAM ? undefined : nav.team;
  let t1;
  if ($[0] !== formTables.form || $[1] !== labels || $[2] !== teamHref) {
    t1 = mapStandingsToTable(formTables.form, labels, ["rank", "team", "played", "points"], [], teamHref);
    $[0] = formTables.form;
    $[1] = labels;
    $[2] = teamHref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const formTable = t1;
  let t2;
  if ($[4] !== formTables.homeForm || $[5] !== labels || $[6] !== teamHref) {
    t2 = mapStandingsToTable(formTables.homeForm, labels, ["rank", "team", "played", "points"], [], teamHref);
    $[4] = formTables.homeForm;
    $[5] = labels;
    $[6] = teamHref;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const homeFormTable = t2;
  let t3;
  if ($[8] !== formTables.awayForm || $[9] !== labels || $[10] !== teamHref) {
    t3 = mapStandingsToTable(formTables.awayForm, labels, ["rank", "team", "played", "points"], [], teamHref);
    $[8] = formTables.awayForm;
    $[9] = labels;
    $[10] = teamHref;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const awayFormTable = t3;
  let t4;
  if ($[12] !== formTables.offence || $[13] !== labels || $[14] !== teamHref) {
    t4 = mapStandingsToTable(formTables.offence, labels, ["rank", "team", "played", "goalsFor"], [], teamHref);
    $[12] = formTables.offence;
    $[13] = labels;
    $[14] = teamHref;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const offenceTable = t4;
  let t5;
  if ($[16] !== formTables.homeOffence || $[17] !== labels || $[18] !== teamHref) {
    t5 = mapStandingsToTable(formTables.homeOffence, labels, ["rank", "team", "played", "goalsFor"], [], teamHref);
    $[16] = formTables.homeOffence;
    $[17] = labels;
    $[18] = teamHref;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const homeOffenceTable = t5;
  let t6;
  if ($[20] !== formTables.awayOffence || $[21] !== labels || $[22] !== teamHref) {
    t6 = mapStandingsToTable(formTables.awayOffence, labels, ["rank", "team", "played", "goalsFor"], [], teamHref);
    $[20] = formTables.awayOffence;
    $[21] = labels;
    $[22] = teamHref;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  const awayOffenceTable = t6;
  let t7;
  if ($[24] !== formTables.defence || $[25] !== labels || $[26] !== teamHref) {
    t7 = mapStandingsToTable(formTables.defence, labels, ["rank", "team", "played", "goalsAgainst"], [], teamHref);
    $[24] = formTables.defence;
    $[25] = labels;
    $[26] = teamHref;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  const defenceTable = t7;
  let t8;
  if ($[28] !== formTables.homeDefence || $[29] !== labels || $[30] !== teamHref) {
    t8 = mapStandingsToTable(formTables.homeDefence, labels, ["rank", "team", "played", "goalsAgainst"], [], teamHref);
    $[28] = formTables.homeDefence;
    $[29] = labels;
    $[30] = teamHref;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  const homeDefenceTable = t8;
  let t9;
  if ($[32] !== formTables.awayDefence || $[33] !== labels || $[34] !== teamHref) {
    t9 = mapStandingsToTable(formTables.awayDefence, labels, ["rank", "team", "played", "goalsAgainst"], [], teamHref);
    $[32] = formTables.awayDefence;
    $[33] = labels;
    $[34] = teamHref;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  const awayDefenceTable = t9;
  let t10;
  if ($[36] !== labels.form.formLast8) {
    t10 = {
      name: labels.form.formLast8
    };
    $[36] = labels.form.formLast8;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      container: "mb-4 text-lg"
    };
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== t10) {
    t12 = <SectionHeader entity={t10} styles={t11} />;
    $[39] = t10;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== formTable.columns || $[42] !== formTable.legend || $[43] !== formTable.rows) {
    t13 = <StatsTable columns={formTable.columns} rows={formTable.rows} legend={formTable.legend} showLegend={true} styles={tableStyles} />;
    $[41] = formTable.columns;
    $[42] = formTable.legend;
    $[43] = formTable.rows;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== t12 || $[46] !== t13) {
    t14 = <div>{t12}{t13}</div>;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  let t15;
  if ($[48] !== labels.form.homeFormLast8) {
    t15 = {
      name: labels.form.homeFormLast8
    };
    $[48] = labels.form.homeFormLast8;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  let t16;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      container: "mb-4 text-lg"
    };
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== t15) {
    t17 = <SectionHeader entity={t15} styles={t16} />;
    $[51] = t15;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== homeFormTable.columns || $[54] !== homeFormTable.rows) {
    t18 = <StatsTable columns={homeFormTable.columns} rows={homeFormTable.rows} styles={tableStyles} />;
    $[53] = homeFormTable.columns;
    $[54] = homeFormTable.rows;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== t17 || $[57] !== t18) {
    t19 = <div>{t17}{t18}</div>;
    $[56] = t17;
    $[57] = t18;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== labels.form.awayFormLast8) {
    t20 = {
      name: labels.form.awayFormLast8
    };
    $[59] = labels.form.awayFormLast8;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  let t21;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      container: "mb-4 text-lg"
    };
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t20) {
    t22 = <SectionHeader entity={t20} styles={t21} />;
    $[62] = t20;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== awayFormTable.columns || $[65] !== awayFormTable.rows) {
    t23 = <StatsTable columns={awayFormTable.columns} rows={awayFormTable.rows} styles={tableStyles} />;
    $[64] = awayFormTable.columns;
    $[65] = awayFormTable.rows;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  let t24;
  if ($[67] !== t22 || $[68] !== t23) {
    t24 = <div>{t22}{t23}</div>;
    $[67] = t22;
    $[68] = t23;
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] !== t14 || $[71] !== t19 || $[72] !== t24) {
    t25 = <div className="grid grid-cols-1 gap-6 md:grid-cols-3">{t14}{t19}{t24}</div>;
    $[70] = t14;
    $[71] = t19;
    $[72] = t24;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  let t26;
  if ($[74] !== labels.form.offence) {
    t26 = {
      name: labels.form.offence
    };
    $[74] = labels.form.offence;
    $[75] = t26;
  } else {
    t26 = $[75];
  }
  let t27;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      container: "mb-4 text-lg"
    };
    $[76] = t27;
  } else {
    t27 = $[76];
  }
  let t28;
  if ($[77] !== t26) {
    t28 = <SectionHeader entity={t26} styles={t27} />;
    $[77] = t26;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  let t29;
  if ($[79] !== offenceTable.columns || $[80] !== offenceTable.rows) {
    t29 = <StatsTable columns={offenceTable.columns} rows={offenceTable.rows} styles={tableStyles} />;
    $[79] = offenceTable.columns;
    $[80] = offenceTable.rows;
    $[81] = t29;
  } else {
    t29 = $[81];
  }
  let t30;
  if ($[82] !== t28 || $[83] !== t29) {
    t30 = <div>{t28}{t29}</div>;
    $[82] = t28;
    $[83] = t29;
    $[84] = t30;
  } else {
    t30 = $[84];
  }
  let t31;
  if ($[85] !== labels.form.homeOffence) {
    t31 = {
      name: labels.form.homeOffence
    };
    $[85] = labels.form.homeOffence;
    $[86] = t31;
  } else {
    t31 = $[86];
  }
  let t32;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      container: "mb-4 text-lg"
    };
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] !== t31) {
    t33 = <SectionHeader entity={t31} styles={t32} />;
    $[88] = t31;
    $[89] = t33;
  } else {
    t33 = $[89];
  }
  let t34;
  if ($[90] !== homeOffenceTable.columns || $[91] !== homeOffenceTable.rows) {
    t34 = <StatsTable columns={homeOffenceTable.columns} rows={homeOffenceTable.rows} styles={tableStyles} />;
    $[90] = homeOffenceTable.columns;
    $[91] = homeOffenceTable.rows;
    $[92] = t34;
  } else {
    t34 = $[92];
  }
  let t35;
  if ($[93] !== t33 || $[94] !== t34) {
    t35 = <div>{t33}{t34}</div>;
    $[93] = t33;
    $[94] = t34;
    $[95] = t35;
  } else {
    t35 = $[95];
  }
  let t36;
  if ($[96] !== labels.form.awayOffence) {
    t36 = {
      name: labels.form.awayOffence
    };
    $[96] = labels.form.awayOffence;
    $[97] = t36;
  } else {
    t36 = $[97];
  }
  let t37;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = {
      container: "mb-4 text-lg"
    };
    $[98] = t37;
  } else {
    t37 = $[98];
  }
  let t38;
  if ($[99] !== t36) {
    t38 = <SectionHeader entity={t36} styles={t37} />;
    $[99] = t36;
    $[100] = t38;
  } else {
    t38 = $[100];
  }
  let t39;
  if ($[101] !== awayOffenceTable.columns || $[102] !== awayOffenceTable.rows) {
    t39 = <StatsTable columns={awayOffenceTable.columns} rows={awayOffenceTable.rows} styles={tableStyles} />;
    $[101] = awayOffenceTable.columns;
    $[102] = awayOffenceTable.rows;
    $[103] = t39;
  } else {
    t39 = $[103];
  }
  let t40;
  if ($[104] !== t38 || $[105] !== t39) {
    t40 = <div>{t38}{t39}</div>;
    $[104] = t38;
    $[105] = t39;
    $[106] = t40;
  } else {
    t40 = $[106];
  }
  let t41;
  if ($[107] !== t30 || $[108] !== t35 || $[109] !== t40) {
    t41 = <div className="grid grid-cols-1 gap-6 md:grid-cols-3">{t30}{t35}{t40}</div>;
    $[107] = t30;
    $[108] = t35;
    $[109] = t40;
    $[110] = t41;
  } else {
    t41 = $[110];
  }
  let t42;
  if ($[111] !== labels.form.defence) {
    t42 = {
      name: labels.form.defence
    };
    $[111] = labels.form.defence;
    $[112] = t42;
  } else {
    t42 = $[112];
  }
  let t43;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = {
      container: "mb-4 text-lg"
    };
    $[113] = t43;
  } else {
    t43 = $[113];
  }
  let t44;
  if ($[114] !== t42) {
    t44 = <SectionHeader entity={t42} styles={t43} />;
    $[114] = t42;
    $[115] = t44;
  } else {
    t44 = $[115];
  }
  let t45;
  if ($[116] !== defenceTable.columns || $[117] !== defenceTable.rows) {
    t45 = <StatsTable columns={defenceTable.columns} rows={defenceTable.rows} styles={tableStyles} />;
    $[116] = defenceTable.columns;
    $[117] = defenceTable.rows;
    $[118] = t45;
  } else {
    t45 = $[118];
  }
  let t46;
  if ($[119] !== t44 || $[120] !== t45) {
    t46 = <div>{t44}{t45}</div>;
    $[119] = t44;
    $[120] = t45;
    $[121] = t46;
  } else {
    t46 = $[121];
  }
  let t47;
  if ($[122] !== labels.form.homeDefence) {
    t47 = {
      name: labels.form.homeDefence
    };
    $[122] = labels.form.homeDefence;
    $[123] = t47;
  } else {
    t47 = $[123];
  }
  let t48;
  if ($[124] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = {
      container: "mb-4 text-lg"
    };
    $[124] = t48;
  } else {
    t48 = $[124];
  }
  let t49;
  if ($[125] !== t47) {
    t49 = <SectionHeader entity={t47} styles={t48} />;
    $[125] = t47;
    $[126] = t49;
  } else {
    t49 = $[126];
  }
  let t50;
  if ($[127] !== homeDefenceTable.columns || $[128] !== homeDefenceTable.rows) {
    t50 = <StatsTable columns={homeDefenceTable.columns} rows={homeDefenceTable.rows} styles={tableStyles} />;
    $[127] = homeDefenceTable.columns;
    $[128] = homeDefenceTable.rows;
    $[129] = t50;
  } else {
    t50 = $[129];
  }
  let t51;
  if ($[130] !== t49 || $[131] !== t50) {
    t51 = <div>{t49}{t50}</div>;
    $[130] = t49;
    $[131] = t50;
    $[132] = t51;
  } else {
    t51 = $[132];
  }
  let t52;
  if ($[133] !== labels.form.awayDefence) {
    t52 = {
      name: labels.form.awayDefence
    };
    $[133] = labels.form.awayDefence;
    $[134] = t52;
  } else {
    t52 = $[134];
  }
  let t53;
  if ($[135] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = {
      container: "mb-4 text-lg"
    };
    $[135] = t53;
  } else {
    t53 = $[135];
  }
  let t54;
  if ($[136] !== t52) {
    t54 = <SectionHeader entity={t52} styles={t53} />;
    $[136] = t52;
    $[137] = t54;
  } else {
    t54 = $[137];
  }
  let t55;
  if ($[138] !== awayDefenceTable.columns || $[139] !== awayDefenceTable.rows) {
    t55 = <StatsTable columns={awayDefenceTable.columns} rows={awayDefenceTable.rows} styles={tableStyles} />;
    $[138] = awayDefenceTable.columns;
    $[139] = awayDefenceTable.rows;
    $[140] = t55;
  } else {
    t55 = $[140];
  }
  let t56;
  if ($[141] !== t54 || $[142] !== t55) {
    t56 = <div>{t54}{t55}</div>;
    $[141] = t54;
    $[142] = t55;
    $[143] = t56;
  } else {
    t56 = $[143];
  }
  let t57;
  if ($[144] !== t46 || $[145] !== t51 || $[146] !== t56) {
    t57 = <div className="grid grid-cols-1 gap-6 md:grid-cols-3">{t46}{t51}{t56}</div>;
    $[144] = t46;
    $[145] = t51;
    $[146] = t56;
    $[147] = t57;
  } else {
    t57 = $[147];
  }
  let t58;
  if ($[148] !== t25 || $[149] !== t41 || $[150] !== t57) {
    t58 = <div className="space-y-8">{t25}{t41}{t57}</div>;
    $[148] = t25;
    $[149] = t41;
    $[150] = t57;
    $[151] = t58;
  } else {
    t58 = $[151];
  }
  return t58;
}